import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChatCircleDots } from '@phosphor-icons/react';

/**
 * FAB (Floating Action Button) — Chat équipe
 * Style WhatsApp/Intercom : bouton rond fixé en bas à droite, visible sur toutes les pages.
 * - Caché automatiquement sur la page /chat elle-même (sinon redondant)
 * - Badge rouge avec compteur si messages non lus
 * - Animation pulse pour attirer l'œil
 */
const ChatFAB = ({ unreadChat = 0 }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Ne pas afficher si on est déjà sur /chat ou sur une route guide/scan public
  const hidden = location.pathname.startsWith('/chat')
    || location.pathname.startsWith('/g/')
    || location.pathname.startsWith('/login');
  if (hidden) return null;

  return (
    <div className="fixed bottom-20 right-6 z-40 flex flex-col items-end gap-1" data-testid="chat-fab">
      {/* Mini-label visible au survol pour clarifier l'affordance */}
      <button
        type="button"
        onClick={() => navigate('/chat')}
        aria-label="Ouvrir le Chat équipe"
        data-testid="chat-fab-button"
        className="group relative flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-emerald-500 to-emerald-600 text-white shadow-lg shadow-emerald-500/40 hover:shadow-xl hover:shadow-emerald-500/60 hover:scale-105 active:scale-95 transition-all"
      >
        {/* Pulse ring discret pour attirer l'œil */}
        <span className="absolute inset-0 rounded-full bg-emerald-400 opacity-30 animate-ping" aria-hidden="true" />
        <ChatCircleDots size={26} weight="fill" className="relative" />

        {/* Badge messages non lus */}
        {unreadChat > 0 && (
          <span
            data-testid="chat-fab-unread"
            className="absolute -top-1 -right-1 min-w-[22px] h-[22px] px-1.5 rounded-full bg-red-500 text-white text-xs font-bold flex items-center justify-center ring-2 ring-white shadow-md"
          >
            {unreadChat > 9 ? '9+' : unreadChat}
          </span>
        )}

        {/* Tooltip "Chat équipe" qui apparaît au survol */}
        <span
          className="absolute right-full mr-3 px-2.5 py-1.5 rounded-lg bg-zinc-900 text-white text-xs font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none shadow-lg"
        >
          Chat équipe
          <span className="absolute right-[-4px] top-1/2 -translate-y-1/2 w-2 h-2 bg-zinc-900 rotate-45" />
        </span>
      </button>
    </div>
  );
};

export default ChatFAB;
